const auctionPanel =
  document.querySelector("[data-auction-panel]");

const bidInput =
  document.querySelector("[data-auction-bid-input]");

const bidButton =
  document.querySelector("[data-auction-submit]");

const bidMessage =
  document.querySelector("[data-auction-bid-message]");

const currentBidElement =
  document.querySelector("[data-auction-current-bid]");

const bidCountElement =
  document.querySelector("[data-auction-bid-count]");

const minimumBidElement =
  document.querySelector("[data-auction-minimum-bid]");

const countdownElement =
  document.querySelector("[data-auction-countdown]");

const historyElement =
  document.querySelector("[data-auction-bid-history]");

const productInfo =
  document.querySelector("product-info");

const shopifyProductId =
  productInfo
    ? productInfo.dataset.productId
    : null;

const customerId =
  productInfo
    ? productInfo.dataset.customerId
    : null;

const auctionFunctionUrl =
  "https://utnqmztyzefozfikpfuz.supabase.co/functions/v1/auction-bid";

let currentBid = 0;
let bidIncrement = 500;
let auctionEndsAt = null;
let auctionHasDate = false;
let countdownInterval = null;


/*
 * FORMATO COLONES
 */

function formatCRC(amount) {
  return `¢${Number(amount).toLocaleString("es-CR")}`;
}


/*
 * ESTADO: NO HA INICIADO
 */

function setAuctionNotStarted() {

  auctionHasDate = false;
  auctionEndsAt = null;

  if (countdownInterval) {
    clearInterval(countdownInterval);
    countdownInterval = null;
  }

  if (countdownElement) {
    countdownElement.innerHTML =
      "No ha iniciado";
  }

  if (minimumBidElement) {
    minimumBidElement.textContent =
      "La subasta aún no ha iniciado.";
  }

  if (bidInput) {
    bidInput.disabled = true;
  }

  if (bidButton) {
    bidButton.disabled = true;
  }
}


/*
 * ESTADO: SUBASTA CON FECHA
 */

function setAuctionActive() {

  auctionHasDate = true;

  if (bidInput) {
    bidInput.disabled = false;
  }

  if (bidButton) {
    bidButton.disabled = false;
  }
}


/*
 * COUNTDOWN
 */

function startCountdown(endDate) {

  if (!countdownElement || !endDate) {
    setAuctionNotStarted();
    return;
  }

  if (countdownInterval) {
    clearInterval(countdownInterval);
  }

  auctionEndsAt =
    new Date(endDate).getTime();

  if (
    !Number.isFinite(auctionEndsAt)
  ) {
    setAuctionNotStarted();
    return;
  }

  setAuctionActive();

  function updateCountdown() {

    const distance =
      auctionEndsAt - Date.now();

    if (distance <= 0) {

      countdownElement.innerHTML =
        "Subasta finalizada";

      if (countdownInterval) {
        clearInterval(countdownInterval);
        countdownInterval = null;
      }

      return;
    }

    const days =
      Math.floor(
        distance /
        (1000 * 60 * 60 * 24)
      );

    const hours =
      Math.floor(
        (distance %
          (1000 * 60 * 60 * 24)) /
        (1000 * 60 * 60)
      );

    const minutes =
      Math.floor(
        (distance %
          (1000 * 60 * 60)) /
        (1000 * 60)
      );

    if (days > 0) {

      countdownElement.innerHTML = `
        <div class="auction-time-box">
          <span class="auction-time-number">
            ${days}
          </span>

          <span class="auction-time-label">
            Días
          </span>
        </div>

        <div class="auction-time-box">
          <span class="auction-time-number">
            ${hours}
          </span>

          <span class="auction-time-label">
            Horas
          </span>
        </div>
      `;

    } else if (hours > 0) {

      countdownElement.innerHTML = `
        <div class="auction-time-box">
          <span class="auction-time-number">
            ${hours}
          </span>

          <span class="auction-time-label">
            Horas
          </span>
        </div>

        <div class="auction-time-box">
          <span class="auction-time-number">
            ${minutes}
          </span>

          <span class="auction-time-label">
            Minutos
          </span>
        </div>
      `;

    } else {

      countdownElement.innerHTML = `
        <div class="auction-time-box">
          <span class="auction-time-number">
            ${minutes}
          </span>

          <span class="auction-time-label">
            Minutos
          </span>
        </div>
      `;
    }
  }

  updateCountdown();

  countdownInterval =
    setInterval(
      updateCountdown,
      60000
    );
}


/*
 * SEGURIDAD HTML
 */

function escapeHTML(value) {

  const div =
    document.createElement("div");

  div.textContent =
    value ?? "";

  return div.innerHTML;
}


/*
 * HISTORIAL
 */

function renderBidHistory(bids) {

  if (!historyElement) {
    return;
  }

  if (!bids || bids.length === 0) {

    historyElement.innerHTML = `
      <div class="auction-history-empty">
        Aún no hay pujas.
      </div>
    `;

    return;
  }

  historyElement.innerHTML = `
    <div class="auction-history-list">

      ${bids.map((bid) => {

        const bidderName =
          bid.bidder_name || "Usuario";

        return `
          <div class="auction-history-item">

            <span>
              ${escapeHTML(bidderName)}
            </span>

            <strong>
              ${formatCRC(bid.amount)}
            </strong>

          </div>
        `;

      }).join("")}

    </div>
  `;
}


/*
 * ACTUALIZAR INTERFAZ
 */

function updateAuctionDisplay(data) {

  currentBid =
    Number(data.current_bid || 0);

  bidIncrement =
    Number(data.bid_increment || 500);

  const minimumBid =
    currentBid + bidIncrement;

  if (currentBidElement) {

    currentBidElement.textContent =
      currentBid > 0
        ? formatCRC(currentBid)
        : "Sin ofertas";
  }

  if (bidCountElement) {

    const count =
      Number(data.bid_count || 0);

    bidCountElement.innerHTML = `
      <span aria-hidden="true">🔨</span>

      <strong>${count}</strong>

      ${count === 1 ? "puja" : "pujas"}
    `;
  }

  if (
    data.ends_at
  ) {

    setAuctionActive();

    if (minimumBidElement) {

      minimumBidElement.textContent =
        `La oferta mínima es ${formatCRC(minimumBid)}`;
    }

    if (bidInput) {
      bidInput.min = minimumBid;
    }

    startCountdown(
      data.ends_at
    );

  } else {

    setAuctionNotStarted();
  }

  renderBidHistory(
    data.bids || []
  );
}


/*
 * CARGAR SUBASTA
 */

async function loadAuction() {

  if (
    !shopifyProductId ||
    !auctionPanel
  ) {

    console.error(
      "No se pudo identificar la subasta."
    );

    return;
  }

  const startingBid =
    Number(
      auctionPanel.dataset.startingBid || 0
    );

  const metafieldCurrentBid =
    Number(
      auctionPanel.dataset.currentBid || 0
    );

  const metafieldBidCount =
    Number(
      auctionPanel.dataset.bidCount || 0
    );

  const auctionEnd =
    auctionPanel.dataset.auctionEnd || null;

  try {

    const response =
      await fetch(
        auctionFunctionUrl,
        {
          method: "POST",

          headers: {
            "Content-Type":
              "application/json"
          },

          body: JSON.stringify({

            action: "get",

            shopify_product_id:
              shopifyProductId,

            starting_bid:
              startingBid,

            current_bid:
              metafieldCurrentBid,

            bid_count:
              metafieldBidCount,

            auction_end:
              auctionEnd

          })
        }
      );

    const data =
      await response.json();

    if (
      !response.ok ||
      !data.success
    ) {

      console.error(
        "Auction load error:",
        data
      );

      return;
    }

    updateAuctionDisplay(data);

  } catch (error) {

    console.error(
      "Auction connection error:",
      error
    );
  }
}


/*
 * ENVIAR PUJA
 */

if (
  bidInput &&
  bidButton &&
  bidMessage
) {

  bidButton.addEventListener(
    "click",
    async function () {

      if (!auctionHasDate) {

        bidMessage.innerHTML =
          "⚠️ La subasta aún no ha iniciado.";

        return;
      }

      const value =
        Number(bidInput.value);

      if (!customerId) {

        bidMessage.innerHTML =
          "⚠️ Debes iniciar sesión para participar en la subasta.";

        return;
      }

      if (!value) {

        bidMessage.innerHTML =
          "⚠️ Ingresa una oferta.";

        return;
      }

      const minimumBid =
        currentBid + bidIncrement;

      if (value < minimumBid) {

        bidMessage.innerHTML =
          `⚠️ Tu oferta mínima debe ser ${formatCRC(minimumBid)}`;

        return;
      }

      bidButton.disabled = true;

      bidMessage.innerHTML =
        "Procesando tu oferta...";

      try {

        const response =
          await fetch(
            auctionFunctionUrl,
            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json"
              },

              body: JSON.stringify({

                action: "bid",

                shopify_product_id:
                  shopifyProductId,

                customer_id:
                  customerId,

                amount:
                  value

              })
            }
          );

        const data =
          await response.json();

        if (
          !response.ok ||
          !data.success
        ) {

          bidMessage.innerHTML =
            `⚠️ ${
              data.error ||
              "No se pudo procesar la puja."
            }`;

          if (auctionHasDate) {
            bidButton.disabled = false;
          }

          return;
        }

        bidMessage.innerHTML =
          `✓ ¡Puja realizada! Oferta actual: ${formatCRC(
            data.current_bid
          )}`;

        await loadAuction();

        bidInput.value = "";

        if (auctionHasDate) {
          bidButton.disabled = false;
        }

      } catch (error) {

        console.error(
          "Auction bid error:",
          error
        );

        bidMessage.innerHTML =
          "⚠️ No se pudo conectar con el servidor.";

        if (auctionHasDate) {
          bidButton.disabled = false;
        }
      }
    }
  );
}


loadAuction();